{
  "tabs": {
    "chat": "Czat",
    "reminders": "Przypomnienia",
    "calendar": "Kalendarz",
    "settings": "Ustawienia"
  },
  "common": {
    "cancel": "Anuluj",
    "save": "Zapisz",
    "confirm": "Potwierdź",
    "delete": "Usuń",
    "back": "Wstecz",
    "close": "Zamknij",
    "edit": "Edytuj",
    "search": "Szukaj",
    "all": "Wszystko",
    "loading": "Ładowanie...",
    "error": "Coś poszło nie tak",
    "notFound": "Nie znaleziono",
    "tryAgain": "Spróbuj ponownie",
    "retry": "Ponów",
    "undo": "Cofnij",
    "pullToRefresh": "Przeciągnij, aby odświeżyć",
    "justNow": "przed chwilą"
  },
  "auth": {
    "welcome": "Witamy w FishMemory",
    "tagline": "Twój asystent przypomnień WhatsApp, teraz w Twojej kieszeni.",
    "subtitle": "Twój asystent przypomnień WhatsApp, teraz w Twojej kieszeni.",
    "phoneLabel": "Twój numer WhatsApp",
    "phoneHint": "Wyślemy kod weryfikacyjny przez WhatsApp",
    "invalidPhone": "Wprowadź poprawny numer telefonu",
    "continue": "Kontynuuj",
    "enterPhone": "Wprowadź swój numer WhatsApp",
    "phonePlaceholder": "Numer telefonu",
    "sendCode": "Wyślij kod",
    "verifyTitle": "Zweryfikuj swój numer",
    "otpSentTo": "6-cyfrowy kod został wysłany na {{phone}} przez WhatsApp",
    "enterFullCode": "Wprowadź wszystkie 6 cyfr",
    "invalidOtp": "Nieprawidłowy kod. Spróbuj ponownie.",
    "otpFailed": "Nie udało się wysłać kodu. Spróbuj ponownie.",
    "otpResent": "Kod wysłany ponownie",
    "resendIn": "Wyślij ponownie za {{seconds}}s",
    "resendCode": "Wyślij kod ponownie",
    "enterOtp": "Wprowadź kod wysłany na WhatsApp",
    "verify": "Weryfikuj",
    "resend": "Wyślij ponownie",
    "wrongNumber": "Zły numer?",
    "backToPhone": "Wróć do numeru",
    "editPhone": "Edytuj numer",
    "error": "Błąd",
    "setupTitle": "Skonfigurujmy to",
    "setupSubtitle": "Zawsze możesz to zmienić w Ustawieniach",
    "namePlaceholder": "Twoje imię",
    "letsGo": "Zakończ konfigurację",
    "skipForNow": "Pomiń na razie"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Napisz wiadomość...",
    "inputPlaceholder": "Napisz wiadomość...",
    "typing": "FishMemory pisze...",
    "online": "Online",
    "connecting": "Łączenie...",
    "reconnecting": "Ponowne łączenie...",
    "offline": "Offline",
    "empty": "Rozpocznij rozmowę",
    "emptyHint": "Twórz przypomnienia, sprawdzaj kalendarz lub poproś o pomoc.",
    "emptyAction": "Wyślij przykładowe przypomnienie",
    "actions": "Akcje czatu",
    "keep": "Zachowaj wiadomości",
    "clearTitle": "Wyczyść czat",
    "clearConfirm": "Usunąć wszystkie wiadomości z tego urządzenia? Operacji nie można cofnąć.",
    "clear": "Wyczyść czat",
    "optionSelected": "Wybrano: {{label}}",
    "sendingSelection": "Wysyłanie...",
    "connectionLost": "Ponowne łączenie..."
  },
  "reminders": {
    "title": "Moje przypomnienia",
    "active": "Aktywne",
    "today": "Dziś",
    "thisWeek": "W tym tygodniu",
    "history": "Historia",
    "items": "elementy",
    "emptyTitle": "Brak przypomnień",
    "emptySubtitle": "Utwórz przypomnienie w czacie, aby pojawiło się tutaj.",
    "emptyAction": "Otwórz czat",
    "filterActive": "Aktywne",
    "filterToday": "Dziś",
    "filterWeek": "W tym tygodniu",
    "filterHistory": "Historia",
    "emptyState": "Brak przypomnień. Zacznij czatować!",
    "swipeDone": "Wykonane",
    "swipeSnooze": "Drzemka",
    "swipeDelete": "Usuń",
    "search": "Szukaj przypomnień...",
    "upcoming": "Nadchodzące",
    "completed": "Zakończone",
    "overdue": "Zaległe",
    "tomorrow": "Jutro",
    "synced": "Zsynchronizowano {{value}}",
    "swipeHint": "Przesuń przypomnienie, aby zobaczyć więcej opcji",
    "noResults": "Brak przypomnień pasujących do wyszukiwania",
    "noResultsHint": "Spróbuj innego słowa kluczowego lub wyczyść wyszukiwanie",
    "deleteAllFailed": "Nie udało się usunąć wszystkich przypomnień"
  },
  "calendar": {
    "title": "Kalendarz",
    "today": "Dziś",
    "tomorrow": "Jutro",
    "completed": "zrobione",
    "noEvents": "Brak zaplanowanych wydarzeń",
    "noEventsSubtitle": "Wybierz datę, aby zobaczyć przypomnienia i wydarzenia.",
    "googleEvent": "Google Calendar",
    "legendActive": "Aktywne",
    "legendRecurring": "Powtarzające się",
    "legendDone": "Wykonane",
    "legendGoogle": "Google",
    "previousMonth": "Poprzedni miesiąc",
    "nextMonth": "Następny miesiąc",
    "previousYear": "Poprzedni rok",
    "nextYear": "Następny rok",
    "goToToday": "Przejdź do dziś",
    "all": "Wszystko",
    "active": "Aktywne",
    "done": "Wykonane",
    "paused": "Wstrzymane"
  },
  "settings": {
    "title": "Ustawienia",
    "profile": "Profil",
    "name": "Nazwa wyświetlana",
    "enterName": "Wprowadź imię",
    "language": "Język",
    "uiLanguage": "Język aplikacji",
    "uiLanguageHelp": "Zmienia język interfejsu, etykiety kalendarza i kierunek układu tylko na tym urządzeniu.",
    "serverLanguage": "Język czatu",
    "serverLanguageHelp": "Zmienia język odpowiedzi serwera i wiadomości przypomnień dla Twojego konta.",
    "timezone": "Strefa czasowa",
    "currentTimezone": "Aktualna strefa czasowa",
    "timezoneHelp": "Wszystkie czasy przypomnień są wyświetlane w tej strefie czasowej.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Zapisz strefę",
    "timezoneSaved": "Strefa czasowa zaktualizowana",
    "detect": "Wykryj",
    "detectFailed": "Nie udało się wykryć strefy czasowej",
    "autoDetect": "Automatyczne wykrywanie z GPS",
    "notifications": "Powiadomienia",
    "notificationsHelp": "Przypomnienia follow-up kontrolują powtarzające się alerty po dostarczeniu przypomnienia. Uprawnienia powiadomień na poziomie urządzenia są zarządzane w ustawieniach telefonu.",
    "pushEnabled": "Powiadomienia push",
    "autoDoneOnFire": "Automatycznie oznacz jako wykonane po wywołaniu",
    "autoDoneOnFireDesc": "Jeśli wyłączone, przypomnienia pozostają aktywne, aż oznaczysz je jako wykonane.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Połączono",
    "googleDisconnected": "Nie połączono",
    "googleConnectedHelp": "Nowe przypomnienia mogą być automatycznie synchronizowane z kalendarzem.",
    "googleDisconnectedHelp": "Połącz Google Calendar, aby zsynchronizować przypomnienia i wydarzenia.",
    "googleConnectFailed": "Nie udało się połączyć Google Calendar",
    "connected": "Połączono",
    "disconnected": "Nie połączono",
    "connect": "Połącz",
    "disconnect": "Rozłącz",
    "autoSync": "Automatyczna synchronizacja nowych przypomnień",
    "autosync": "Automatyczna synchronizacja nowych przypomnień",
    "subscription": "Subskrypcja",
    "trialUsed": "Okres próbny: {{used}}/{{total}} użyte",
    "trialStatus": "Okres próbny dostępny",
    "activeStatus": "Aktywna subskrypcja",
    "expiredStatus": "Subskrypcja wygasła",
    "unsubscribedStatus": "Brak subskrypcji",
    "about": "O aplikacji",
    "version": "Wersja",
    "logout": "Wyloguj się",
    "logoutTitle": "Wyloguj się",
    "logoutConfirm": "Czy na pewno chcesz się wylogować?",
    "noName": "Brak nazwy",
    "serverConnection": "Połączenie z serwerem",
    "serverUrl": "Adres serwera",
    "serverEdit": "Edytuj",
    "saveReconnect": "Zapisz i połącz ponownie",
    "resetDefault": "Przywróć domyślne",
    "invalidServerUrlTitle": "Nieprawidłowy adres serwera",
    "invalidServerUrlMessage": "Wprowadź poprawny adres serwera http lub https, np. https://example.com",
    "uiLanguageChangeFailed": "Nie udało się zmienić języka aplikacji. Spróbuj ponownie.",
    "serverLanguageChangeFailed": "Nie udało się zmienić języka czatu. Spróbuj ponownie.",
    "timezoneChangeFailed": "Nie udało się zmienić strefy czasowej. Spróbuj ponownie.",
    "autoSyncChangeFailed": "Nie udało się zaktualizować automatycznej synchronizacji. Spróbuj ponownie.",
    "nameChangeFailed": "Nie udało się zaktualizować nazwy wyświetlanej. Spróbuj ponownie.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Szczegóły przypomnienia",
    "editTime": "Edytuj czas",
    "rename": "Zmień nazwę",
    "snooze": "Drzemka",
    "snooze15": "Drzemka 15 minut",
    "pause": "Wstrzymaj",
    "pauseReminder": "Wstrzymaj przypomnienie",
    "resume": "Wznów",
    "resumeReminder": "Wznów przypomnienie",
    "skip": "Pomiń następne",
    "skipOccurrence": "Pomiń to wystąpienie",
    "syncGoogle": "Synchronizuj z Google",
    "delete": "Usuń",
    "deleteTitle": "Usuń przypomnienie",
    "deleteConfirm": "To przypomnienie zostanie trwale usunięte.",
    "deleteRecurringTitle": "Usuń powtarzające się przypomnienie",
    "deleteRecurringMessage": "Czy chcesz pominąć to wystąpienie czy usunąć całą serię?",
    "deleteThisOccurrence": "Pomiń to wystąpienie",
    "deleteEntireSeries": "Usuń całą serię",
    "done": "Wykonane",
    "markDone": "Oznacz jako wykonane",
    "undo": "Przywróć",
    "undoPrompt": "Potrzebujesz ponownie aktywować? Przywróć teraz.",
    "recurring": "Powtarzające się",
    "nextRun": "Następne uruchomienie",
    "oneTime": "Jednorazowe",
    "pending": "Oczekujące",
    "sent": "Wysłane",
    "paused": "Wstrzymane",
    "active": "Aktywne",
    "snoozed": "Uśpione",
    "localTime": "Wyświetlane w Twojej lokalnej strefie czasowej",
    "recurrence": "Powtarzalność",
    "created": "Utworzone",
    "tags": "Tagi",
    "fireCount": "Ilość wywołań",
    "actions": "Akcje",
    "none": "Brak",
    "snoozeFailed": "Nie udało się uśpić przypomnienia",
    "pauseFailed": "Nie udało się wstrzymać przypomnienia",
    "resumeFailed": "Nie udało się wznowić przypomnienia",
    "skipFailed": "Nie udało się pominąć przypomnienia",
    "doneFailed": "Nie udało się oznaczyć przypomnienia jako wykonanego",
    "undoFailed": "Nie udało się przywrócić statusu przypomnienia",
    "deleteFailed": "Nie udało się usunąć przypomnienia",
    "rescheduleTitle": "Przełożyć?",
    "rescheduleMsg": "To przypomnienie jest zaległe. Czy chcesz je przełożyć?",
    "reschedule15": "Za 15 minut",
    "reschedule60": "Za 1 godzinę",
    "keepOverdue": "Zachowaj jak jest"
  },
  "onboarding": {
    "slide1Title": "Witamy w FishMemory",
    "slide1Sub": "Twój osobisty asystent przypomnień — zasilany przez WhatsApp i stworzony do kieszeni.",
    "slide2Title": "Po prostu czatuj naturalnie",
    "slide2Sub": "Wpisuj przypomnienia tak, jak myślisz: „Przypomnij mi zadzwonić do mamy jutro o 15” — resztę załatwimy my.",
    "slide3Title": "Nigdy nic nie przegap",
    "slide3Sub": "Otrzymuj powiadomienia na czas, organizuj tagami i miej wszystko pod kontrolą.",
    "getStarted": "Zaczynamy",
    "next": "Dalej",
    "firstReminderTitle": "Utwórz pierwsze przypomnienie!",
    "firstReminderHint": "Spróbuj wpisać coś takiego:",
    "firstReminderExample": "Przypomnij mi, aby pić wodę jutro o 9:00",
    "gotIt": "Zrozumiałem!",
    "notifRationaleTitle": "Bądź na czas",
    "notifRationaleBody": "FishMemory potrzebuje powiadomień, aby przypominać Ci na czas. Otrzymasz alerty tylko dla utworzonych przypomnień.",
    "notifRationaleAllow": "Włącz powiadomienia",
    "notifRationaleLater": "Może później",
    "swipeHint": "Przesuń w prawo, aby szybko działać →",
    "calendarDragHint": "Przeciągnij, aby rozwinąć ↕"
  }
}
